import { render, staticRenderFns } from "./ProductCardVertical.vue?vue&type=template&id=07cdfeec&"
import script from "./ProductCardVertical.vue?vue&type=script&lang=js&"
export * from "./ProductCardVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports